import { MarkdownPipe } from '@adaptiva/core/markdown';
import { SpinnerComponent } from '@adaptiva/widgets/spinner';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { BaseBubbleComponent } from '../../classes';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		MarkdownPipe,
		SpinnerComponent,
	],
	selector: 'div[ada-chat-bubble]',
	styleUrls: ['./chat-bubble.component.scss'],
	templateUrl: './chat-bubble.component.html',
	host: {
		'[class.ada-chat-bubble-wrapper]': 'true',
		'[class.ada-chat-query]': 'isQuery()',
		'[class.ada-chat-response]': '!isQuery()'
	},
	encapsulation: ViewEncapsulation.None
})
export class ChatBubbleComponent extends BaseBubbleComponent {

}
